import React, {useState, useEffect} from 'react'

import "./Assessments.css"
import Sidebar from "../../shared/sidebar/Sidebar"
import Navbar from "../../shared/navbar/Navbar"
import DataTable from "../../shared/datatable/DataTable"
import axios from 'axios'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { format } from 'fecha';
import ErrorMessages from '../../shared/errormessages/ErrorMessages';
import PreviewIcon from '@mui/icons-material/Preview';
import AssessmentEditor from './Editor'

const UserAssessments = () => {

  const [pageState, setPageState] = useState({ loading: false})
  const [pageData, setPageData] = useState({
      status: "",
      data: [],
      total: 0
  })
  const [editorState, setEditorState] = useState({open: false, data: null})

  const [errors, setErrors] = useState("")
  const [search, setSearch] = useState("")
  const [managerType, setManagerType] = useState(0)

  useEffect(()=>{
    if(pageState.loading == false){
      axios.get('/userassessments/getlist?search=' + search + '&type=' + managerType)
        .then(function (response) {
          if(response.data.status == "success"){
            setErrors("");
            setPageData(response.data);
            setPageState({loading: true});
          }
          else{
            setErrors(response.data.message);
          }
        })
        .catch(function (error) {
          setErrors(error.message);
        });
    }
  })

  const downloadReport = (params) => {
    axios({
      url: '/assessment?id=' + params.rows.Id + '&preview=false',
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'report.pdf');
      document.body.appendChild(link);
      link.click();
    });
  };

  const handleOnCellClick = (params) => {
    setEditorState({ open: true, data: params.row});
  };

  const model = {
    columns: [
      {
        field: "FullName",
        headerName: "User",
        width: 130,
        renderCell: (params) => {
          return (
            <div className="cellWithLink" onClick={()=> handleOnCellClick(params)}>
              {params.row.FullName}
            </div>
          );
        },
      },
    {
        field: "ManagerType",
        headerName: "Type",
        width: 100,
        renderCell: (params)=>{
            return(
            <span>{params.row.ManagerType == 1 ? "FTM" : "MM"}</span>
            );
        }
        },
        {
            field: "StartedOn",
            headerName: "Started On",
            width: 150,
            renderCell: (params)=>{
              return(
                params.row.StartedOn &&
                <span>{format(new Date(params.row.StartedOn), 'DD/MM/YYYY HH:mm')}</span>
              );
            }
          },
          {
            field: "StoppedOn",
            headerName: "Stopped On",
            width: 150,
            renderCell: (params)=>{
              return(
                params.row.StoppedOn &&
                <span>{format(new Date(params.row.StoppedOn), 'DD/MM/YYYY HH:mm')}</span>
              );
            }
          },
        {
          field: "TotalSituationsAnswered",
          headerName: "Situations",
          width: 100,
          renderCell: (params) => {
            return (
              <div><b>{params.row.TotalSituationsAnswered}</b>/{params.row.TotalSituations}</div>
            );
          }
        },
        {
          field: "Stage",
          headerName: "Review",
          width: 80,
          renderCell: (params) => {
              return (
                <div>
                  {((params.row.Stage == 1) ? <a href={axios.defaults.baseURL + '/pdf/charts?id=' + params.row.Id} target="_blank"><PreviewIcon/></a> : "")}
                  {((params.row.Stage == 0) && <span>In process..</span>)}
                  {((params.row.Stage == 2) && <span>Failed...</span>)}
                </div>
              );
            },
        },
        {
          field: "ReportSent",
          headerName: "Report Sent",
          width: 170,
          renderCell: (params) => {
              return (
                <div className={`cellWithStatus ${params.row.ReportSent}`} onClick={()=> downloadReport(params)}>
                 <span>{params.row.ReportSent && <span>{format(new Date(params.row.ReportSentOn), 'DD/MM/YYYY HH:mm')}</span>}</span>
                 <span>{!params.row.ReportSent && "NO"}</span>
                 {params.row.ReportUrl != null && <a href={axios.defaults.baseURL + params.row.ReportUrl} target="_blank"><DownloadForOfflineIcon /></a>}
                </div>
              );
            },
        },
        {
          field: "Function",
          headerName: "Function",
          width: 120
        },
      {
        field: "CreatedOn",
        headerName: "Created On",
        width: 150,
        renderCell: (params)=>{
          return(
            params.row.CreatedOn &&
            <span>{format(new Date(params.row.CreatedOn), 'DD/MM/YYYY HH:mm')}</span>
          );
        }
      },
    ],
    modulename: "Assessments"
  };


  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar title={model.modulename}/>
        <ErrorMessages message={errors}/>
        {
          editorState.open == true ? 
          <AssessmentEditor data={editorState} setEditorState={setEditorState} setPageState={setPageState} setErrors={setErrors} /> : 
          <DataTable  {...model} rows={pageData.data} checkboxSelection={true} setPageState={setPageState} setSearch={setSearch} setManagerType={setManagerType} setEditorState={setEditorState} />
        }
        
      </div>
    </div>
  )
}

export default UserAssessments